module.exports = __webpack_public_path__ + "img/honorary5.7bd69b09.jpg";